/**************************************************
 * Nombre:       Proceso_Compra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import agave from '../../../../Recursos/Temporales/agave.svg'
import linea from '../../../../Recursos/linea.svg'
import {FiberManualRecord} from '@mui/icons-material'

const Proceso_Compra = () => {

    const Paso = () => {
        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <FiberManualRecord color={'primary'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography>Uno</Typography>
                </Grid>

            </Grid>
        )
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#F3FFFF',
                p: 4,

            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 1}} sx={{justifyContent: 'flex-start', mt: -2}}>
                <img src={agave} alt="Agave" width={40} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 11}}
                sx={{pl: 2, pb: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 600, fontSize: 16}}>
                        Proceso de Compra
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 400, fontSize: 14, color: '#00000050', lineHeight: 1.1}}>
                        Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos
                    </Typography>
                </Grid>


            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 1.5}} sx={{justifyContent: 'flex-start'}}>
                <Paso/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                <img src={linea} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 1.5}} sx={{justifyContent: 'flex-start'}}>
                <Paso/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                <img src={linea} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 1.5}} sx={{justifyContent: 'flex-start'}}>
                <Paso/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                <img src={linea} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 1.5}} sx={{justifyContent: 'flex-start'}}>
                <Paso/>
            </Grid>

        </Grid>
    )

}
export default Proceso_Compra